import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { BranchesComponent } from "../../Components/Branches/BranchesComponent";

export const Branches = () => {
  return (
    <Wrapper header={"Branch"}>
      <BranchesComponent />
    </Wrapper>
  );
};
